 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		74: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"BizKycBusinessActivities~BizKycInformation~BizKycIntendedRelations~BizKycReview~BizKycStatus~BizKycU~435d50f9","2":"StraitsXBizKycAccountManager~StraitsXBizKycBusinessActivities~StraitsXBizKycComplete~StraitsXBizKycD~ee002959","3":"vendors~BizKycBusinessActivities~BizKycInformation~BizKycIntendedRelations~BizKycReview~BizKycStatus~30c8af64","7":"vendors~GetStarted~LandingPage~MintSetup~MyAccount~StraitsXLandingPage~StraitsXMyAccount","10":"GetStarted~MintSetup~MyAccount~StraitsXMyAccount","11":"StraitsXTransactionDetails~StraitsXTransactions~TransactionDetails~Transactions","14":"Deposit~Mint~StraitsXDeposit","15":"Earn~Mint~Verification","16":"vendors~LandingPage~MintSetup~StraitsXLandingPage","19":"StraitsXBizKycDirectorsAndBo~StraitsXBizKycUploadDocuments","20":"StraitsXVerification~VerificationClaimKyc","21":"Verification~VerificationClaimKyc","22":"vendors~LandingPage~StraitsXLandingPage","25":"BizKycBusinessActivities","26":"BizKycInformation","27":"BizKycIntendedRelations","28":"BizKycReview","29":"BizKycStatus","30":"BizKycUploadDocuments","31":"Deposit","32":"Earn","33":"EarnTransactionDetails","34":"Error","35":"GetStarted","36":"InternalTools","37":"LandingPage","38":"Mint","39":"MintSetup","40":"MyAccount","41":"NotFound","42":"StraitsXAccountStatement","43":"StraitsXBizKycAccountManager","44":"StraitsXBizKycBusinessActivities","45":"StraitsXBizKycComplete","46":"StraitsXBizKycDirectorsAndBo","47":"StraitsXBizKycInformation","48":"StraitsXBizKycIntendedRelations","49":"StraitsXBizKycReview","50":"StraitsXBizKycTaxResidency","51":"StraitsXBizKycUploadDocuments","52":"StraitsXDeposit","53":"StraitsXDeveloperTools","54":"StraitsXEarn","55":"StraitsXEarnTransactionDetails","56":"StraitsXLandingPage","57":"StraitsXMyAccount","58":"StraitsXSimulateDeposit","59":"StraitsXTransactionDetails","60":"StraitsXTransactions","61":"StraitsXVerification","62":"StraitsXWithdraw","63":"Team","64":"TransactionDetails","65":"Transactions","66":"Verification","67":"VerificationClaimKyc","68":"Withdraw","69":"XIDRGetStarted","70":"XIDRSandbox","71":"XIDRTeam","72":"XIDRTransactionDetails","73":"XIDRTransactions","75":"vendors~Verification"}[chunkId]||chunkId) + "." + {"0":"93c77ba2","1":"c60dd0a5","2":"cf2c5e32","3":"28cae4ad","4":"4087dea8","5":"379eacd5","6":"31a0a0b3","7":"19d3a9c7","8":"5906f4b0","9":"6c18747f","10":"958543f8","11":"4736c40a","12":"e9f1bf50","13":"0f1f9ef1","14":"42c3afea","15":"2beb7d69","16":"03a4c69c","17":"97e1e6c9","18":"1b0b6637","19":"e240fcf8","20":"5ca6e621","21":"5dd8d013","22":"75767a35","23":"ff2f993b","24":"8ec36b6f","25":"2de4e3e0","26":"64f6aa06","27":"f77a3d9e","28":"5c27b30b","29":"09ecf0fc","30":"dd759d1c","31":"a173dfb1","32":"3b2663aa","33":"e378cdfa","34":"fcd3ed47","35":"415390e5","36":"dc74e75e","37":"3590b732","38":"9aadaca2","39":"5c45add0","40":"c2c23cda","41":"e31a2ce0","42":"500e8663","43":"7723a434","44":"275754c2","45":"da9426c7","46":"1fa8f0b0","47":"1895776a","48":"b98192db","49":"6f2c61d2","50":"94529948","51":"430c1c2c","52":"b374ca50","53":"6aa0b2f6","54":"6e9a6329","55":"e2a73dd7","56":"ae715bb3","57":"6bad63b2","58":"e4835e83","59":"cc91dc59","60":"f63486c6","61":"cb622e15","62":"0ed5d1cc","63":"ec2e4bd7","64":"e2601820","65":"0d44427c","66":"ec584e5a","67":"98c710cf","68":"facd3406","69":"663867fb","70":"ba448eb0","71":"226b856a","72":"f6dc8e78","73":"3fe9e319","75":"58cb03dc","76":"d6289c52","77":"b573d9e4","78":"437d6b27","79":"79eaa550","80":"67a6b352","81":"a1512c66","82":"54a8f548","83":"f6316376","84":"e5eef5a4","85":"60f01079","86":"5f90d188","87":"cb471b27"}[chunkId] + ".sg.xidr-biz.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 526);
